import React from "react";
import "./Footer.css";
import Icons from "../../../../Config/Images";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const Footer = () => {
  const navigate = useNavigate();
  const { isLoggedIn, user } = useSelector((state) => state.authSlice);

  const handleHomeClick = () => {
    if (isLoggedIn) {
      navigate("/home");
    } else {
      navigate("/");
    }
  };

  return (
    <>
      <div className="footer-div">
        <div className="footer-content">
          <div className="footer-left">
            <div className="left-up">
              <div className="left-up-1">
                <ul className="lists">
                  <div className="head">
                    <p>Quick links</p>
                  </div>
                  <div className="li-links">
                    <li
                      style={{ cursor: "pointer" }}
                      onClick={() => handleHomeClick()}
                    >
                      Home
                    </li>
                    <li
                      style={{ cursor: "pointer" }}
                      // onClick={() => navigate("/about-us")}
                      onClick={() =>
                        isLoggedIn
                          ? navigate("/about-us", {
                              state: { fromAboutUsByLoggedInUser: true },
                            })
                          : navigate("/about-us")
                      }
                    >
                      About Us
                    </li>
                    <li
                      style={{ cursor: "pointer" }}
                      // onClick={() => navigate("/contact-us")}
                      onClick={() =>
                        isLoggedIn
                          ? navigate("/contact-us", {
                              state: { fromContactUsByLoggedInUser: true },
                            })
                          : navigate("/contact-us")
                      }
                    >
                      Contact Us
                    </li>
                    <li
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/partners")}
                    >
                      Partners Community
                    </li>
                    {/* <li
                      style={{ cursor: "pointer" }}
                      // onClick={() => navigate("/about-us")}
                    >
                      Our Blog
                    </li> */}
                  </div>
                </ul>
              </div>

              <div className="left-up-2">
                <ul className="lists">
                  <div className="head">
                    <p>Information</p>
                  </div>
                  <div className="li-links">
                    <li
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/privacy-policy")}
                    >
                      Privacy Policy
                    </li>
                    <li
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/terms-and-conditions")}
                    >
                      Terms & Conditions
                    </li>
                    <li
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/")}
                    >
                      FAQs
                    </li>
                  </div>
                </ul>
              </div>

              <div className="left-up-3">
                <ul className="lists">
                  <div className="head">
                    <p>Contact us</p>
                  </div>
                  <div className="li-links">
                    <div
                      className="sms"
                      style={{
                        display: "flex",
                        marginBottom: "5px",
                        gap: "15px",
                      }}
                    >
                      <img
                        style={{ height: "18px", width: "18px" }}
                        src={Icons.smsIcon}
                        alt=""
                      />
                      <a
                        href="mailto:zabaliofficial@gmail.com"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <li>zabaliofficial@gmail.com</li>
                      </a>
                    </div>

                    <div
                      className="contact"
                      style={{
                        display: "flex",
                        marginBottom: "5px",
                        gap: "15px",
                      }}
                    >
                      <img
                        style={{ height: "18px", width: "18px" }}
                        src={Icons.callIcon}
                        alt=""
                      />
                      <a
                        href="tel:9974943699"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <li>9974943699</li>
                      </a>
                    </div>

                    <div
                      className="address"
                      style={{
                        display: "flex",
                        marginBottom: "5px",
                        gap: "15px",
                      }}
                    >
                      <img
                        style={{ height: "18px", width: "18px" }}
                        src={Icons.buildingIcon}
                        alt=""
                      />
                      <a
                        href="https://www.google.com/maps/place/Zabali+Jewelex+Pvt.+limited/@23.0241946,72.5857343,17z/data=!3m1!4b1!4m6!3m5!1s0x395e8518feed87b3:0x16b471c24a06eb96!8m2!3d23.0241946!4d72.5883146!16s%2Fg%2F11lyxthxg8?entry=ttu&g_ep=EgoyMDI1MDMyNC4wIKXMDSoJLDEwMjExNjQwSAFQAw%3D%3D"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <li>
                          201, Shekh Sariya (Simni Chember), Manek Chowk Rd,
                          near Jain Derasar, Luharni Pole, Ahmedabad, Gujarat
                          380001
                        </li>
                      </a>
                    </div>
                  </div>
                </ul>
              </div>
            </div>
            <div className="left-down">
              <p>Follow us on :</p>
              <div className="social-icons">
                <a
                  href="https://www.instagram.com/zabali.co/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{ height: "24px", width: "24px" }}
                    src={Icons.instagramIcon}
                    alt=""
                  />
                </a>
                <a
                  href="https://www.facebook.com/share/1DgxdRw76R/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{ height: "24px", width: "24px" }}
                    src={Icons.faceBookIcon}
                    alt=""
                  />
                </a>
                <a
                  href="https://wa.me/919974943699"
                  // href="https://wa.me/7619786322"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{ height: "24px", width: "24px" }}
                    src={Icons.whatsAppIcon}
                    alt="WhatsApp"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="footer-right">
            <div className="heading">
              <p>
                Download the <br /> ZABALI app now
              </p>
            </div>
            <div className="qr-scanner">
              <img
                style={{ height: "100px", width: "100px" }}
                src={Icons.androidQrIcon}
                alt=""
              />
              &nbsp; &nbsp;
              <img
                style={{ height: "100px", width: "100px" }}
                src={Icons.iosQrIcon}
                alt=""
              />
            </div>
            <div className="download-options">
              <div className="google-play">
                <a
                  href="https://play.google.com/store/apps/details?id=com.zabalireactnative"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{ height: "30px", width: "86px" }}
                    // style={{ height: "24px", width: "74px" }}
                    src={Icons.downloadGooglePlayIcon}
                    alt=""
                  />
                </a>
              </div>
              <div className="app-store">
                <a
                  href="https://apps.apple.com/in/app/zabali-jewelex/id6739798054"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    // style={{ height: "24px", width: "74px" }}
                    style={{ height: "30px", width: "86px" }}
                    src={Icons.downloadAppStoreIcon}
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom">
          <div
            className="hr"
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "#D3D3D3",
              marginTop: "20px",
            }}
          >
            {/* <hr style={{ marginTop: "20px" }} /> */}
            {/* <img style={{height:"3px"}} src={Icons.footerLineIcon} alt="" /> */}
          </div>
          <div className="copy-right">
            <p>@ ZABALI All Rights Reserved .</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
